
import { map, tap } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import * as Rx from 'rxjs';
import { forkJoin } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()

export class ApiServices {
    URL_API = environment.apiUrl
    constructor(private http: HttpClient) { }
    public agilWalletApiCall(endpoint: any, method: any, data: any) {
        const headers = new HttpHeaders({ "Content-Type": "application/json;", "Accept-Language": localStorage.getItem('language') ?? "" });
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "Accept-Language": localStorage.getItem('language') ?? "" }),
            withCredentials: true
        };
        switch (method) {
            case "GET":
                return this.http.get(this.URL_API + endpoint, { headers: headers, params: data, withCredentials: true }).pipe(
                    map((response: any) => {
                        //console.log("www");
                        console.log(response)
                        if (response.status != 200) {
                            throw new Error(response.status.toString());
                        }
                        else {
                            return response;
                        }
                    }))
            case "POST":
                return this.http.post(this.URL_API + endpoint, data, httpOptions).pipe(map((response: any) => {
                    console.log(response)
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));

            case "PUT":
                return this.http.put(this.URL_API + endpoint, data, { headers: headers, withCredentials: true }).pipe(map((response: any) => {
                    console.log(response)
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));

            case "DELETE":
                return this.http.delete(this.URL_API + endpoint, { headers: headers, body: data, withCredentials: true }).pipe(map((response: any) => {
                    console.log(response)
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));
            default:
                throw new Error(`Método ${method} no soportado`);
        }
    }

    public wolfPublicApiCall(endpoint: any, method: any, data: any) {
        const headers = new HttpHeaders({ "Content-Type": "application/json", "Accept-Language": localStorage.getItem('language') ?? "" });
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "Accept-Language": localStorage.getItem('language') ?? "" }),
            withCredentials: true
        };
        switch (method) {

            case "GET":
                return this.http.get(this.URL_API + endpoint, { headers: headers, params: data, withCredentials: true }).pipe(
                    map((response: any) => {
                        console.log(response)
                        if (response.status != 200) {
                            throw new Error(response.status.toString());
                        }
                        else {
                            return response;
                        }
                    }));

            case "GOT":
                return this.http.get(this.URL_API + endpoint, { headers: headers, params: data, withCredentials: true }).pipe(
                    map((response: any) => {
                        console.log(response)
                        if (response.code != 200) {
                            throw new Error(response.status.toString());
                        }
                        else {
                            return response;
                        }
                    }));

            case "POST":
                return this.http.post(this.URL_API + endpoint, data, httpOptions).pipe(
                    map((response: any) => {
                        console.log(response)
                        if (response.status != 200) {
                            throw new Error(response.status.toString());
                        }
                        else {
                            return response;
                        }
                    }));

            default:
                throw new Error(`Método ${method} no soportado`);
        }
    }

    public wolfExternalApiCall(endpoint: any, method: any, data: any) {
        const headers = new HttpHeaders({ "Content-Type": "application/json", "Accept-Language": "es" });
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "Accept-Language": "es" }),
            withCredentials: true
        };
        switch (method) {
            case "GET":
                return this.http.get(endpoint, { headers: headers, withCredentials: true }).pipe(
                    map((response: any) => {
                        if (response.status != 200) {
                            throw new Error(response.status.toString());
                        }
                        else {
                            return response;
                        }
                    }))
            case "POST":
                return this.http.post(this.URL_API + endpoint, data, httpOptions).pipe(map((response: any) => {
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));

            case "PUT":
                return this.http.put(this.URL_API + endpoint, data, httpOptions).pipe(map((response: any) => {
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));

            case "DELETE":
                return this.http.delete(this.URL_API + endpoint, { headers: headers, body: data }).pipe(map((response: any) => {
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));
            default:
                throw new Error(`Método ${method} no soportado`);
        }
    }


    public agilWalletApiForkJoinCall(resources: any) {
        const headers = new HttpHeaders({ "Content-Type": "application/json", "Accept-Language": localStorage.getItem('language') ?? "" });
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "Accept-Language": localStorage.getItem('language') ?? "" }),
            withCredentials: true
        };
        let arrayResources: any = [];
        Object.keys(resources).forEach((key, index) => {
            if (resources[key].method == "GET")
                arrayResources.push(this.http.get(this.URL_API + resources[key].endpoint, { headers: headers, params: resources[key].data, withCredentials: true }));
            if (resources[key].method == "POST")
                arrayResources.push(this.http.post(this.URL_API + resources[key].endpoint, resources[key].data, httpOptions));
            if (resources[key].method == "PUT")
                arrayResources.push(this.http.put(this.URL_API + resources[key].endpoint, resources[key].data, httpOptions));
            if (resources[key].method == "DELETE")
                arrayResources.push(this.http.delete(this.URL_API + resources[key].endpoint, { headers: headers, body: resources[key].data }));
        });
        return forkJoin(arrayResources).pipe(map((response: any) => {
            if (response.length <= 0) {
                throw new Error("Error getting data");
            }
            else {
                return response;
            }
        }));
    }

    public pingApiCall(endpoint: any, method: any, data: any) {
        const headers = new HttpHeaders({ "Content-Type": "application/json;", "Accept-Language": localStorage.getItem('language') ?? "" });
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "Accept-Language": "en" }),
            withCredentials: true
        };
        switch (method) {
            case "GET":
                return this.http.get(this.URL_API + endpoint, { headers: headers, params: data, withCredentials: true }).pipe(
                    tap(res => (localStorage["data"] = JSON.stringify(res))),
                    map(res => true, (error: any) => false)
                );
            default:
                throw new Error(`Método ${method} no soportado`);
        }
    }

    public apiCall(endpoint: any, method: any, data: any) {
        const headers = new HttpHeaders({ "Content-Type": "application/json;", "Accept-Language": "es" });
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "Accept-Language": "es" }),
            withCredentials: true
        };
        switch (method) {
            case "GET":
                return this.http.get(this.URL_API + endpoint, { headers: headers, params: data, withCredentials: true }).pipe(
                    map((response: any) => {
                        console.log(response)
                        if (response.status != 200) {
                            throw new Error(response.status.toString());
                        }
                        else {
                            return response;
                        }
                    }))
            case "POST":
                return this.http.post(this.URL_API + endpoint, data, httpOptions).pipe(map((response: any) => {
                    console.log(response)
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));

            case "PUT":
                return this.http.put(this.URL_API + endpoint, data, httpOptions).pipe(map((response: any) => {
                    console.log(response)
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));

            case "DELETE":
                return this.http.delete(this.URL_API + endpoint, httpOptions).pipe(map((response: any) => {
                    console.log(response)
                    if (response.status != 200) {
                        throw new Error(response.status.toString());
                    }
                    else {
                        return response;
                    }
                }));
            default:
                throw new Error(`Método ${method} no soportado`);
        }

    }

}